import { cn } from './cn.js';

const initials = (name: string) =>
  name
    .split(/[\s.@-]+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((p) => p[0]?.toUpperCase())
    .join('');

export function Avatar({ name, size = 32, className }: { name: string; size?: number; className?: string }) {
  return (
    <span
      aria-hidden
      style={{ width: size, height: size, fontSize: size * 0.38 }}
      className={cn(
        'inline-flex shrink-0 items-center justify-center rounded-pill bg-navy-50 font-display font-bold text-navy-600',
        className,
      )}
    >
      {initials(name)}
    </span>
  );
}
